export const PLAN_TYPE_BASIC = 'basic';
export const PLAN_TYPE_PREMIUM = 'premium';

export const VALID_PLAN_TYPES = [
  PLAN_TYPE_BASIC,
  PLAN_TYPE_PREMIUM
];

export const PLAN_TYPE_OPTIONS = [
  { label: 'Basic', value: PLAN_TYPE_BASIC },
  { label: 'Premium', value: PLAN_TYPE_PREMIUM },
];
